import React from 'react'
import logoImg from '../../../assets/logo-Innovia.png';
import { NavLink } from "react-router-dom";
import { sideBarNavigation } from '../../../utility/Constant';
import { FaChevronDown } from 'react-icons/fa';
import NestedSideButton from './NestedSideButton';

const ChevronIcon = FaChevronDown as unknown as () => JSX.Element;


function Sidebar() {
    return (
        <div className='bg-white fixed top-4 left-6 w-[22rem] rounded-2xl shadow-xl'>
            <div className="w-full flex flex-col items-center gap-4 py-6 px-4">
                <div>
                    <img src={logoImg} alt="logo" className='w-28' />
                </div>
                <hr className="w-full h-px mt-0 bg-transparent bg-gradient-to-r from-transparent via-black/40 to-transparent dark:bg-gradient-to-r dark:from-transparent dark:via-white dark:to-transparent" />

                <div className='sidebar w-full mt-2 h-[72vh] overflow-y-auto'>
                    <ul className='w-full flex flex-col items-center gap-2'>
                   
                        {sideBarNavigation.map((item, idx) =>
                            item.subUrl?.length ? (
                                <NestedSideButton key={idx} index={idx} items={item} />
                            ) : (
                                <li
                                    key={idx}
                                    className='w-full'
                                >
                                    <NavLink
                                        end
                                        to={`/${item.url}`}
                                        className={({ isActive }) =>
                                     
                                            isActive ? '' : 'w-full py-2.5 hover:bg-[#DB0029]/10 text-sm my-0 flex items-center gap-4 whitespace-nowrap rounded-lg px-4 font-semibold text-slate-700 transition-colors'
                                        }
                                    >
                                        <span className='text-2xl'>
                                            {item.icon}
                                        </span>
                                        <span>{item.title}</span>
                                        {item.subUrl?.length! > 0 &&
                                            <span>
                                                <ChevronIcon />{" "}
                                            </span>
                                        }
                                    </NavLink>
                                </li>
                            )
                        )}
                    </ul>

                </div>
            </div>

            <div className='px-4'>
                <hr className="w-full h-px mt-0 bg-transparent bg-gradient-to-r from-transparent via-black/40 to-transparent dark:bg-gradient-to-r dark:from-transparent dark:via-white dark:to-transparent" />
            </div>
            <div className="w-full py-4 hidden md:block">
                <p className="text-center whitespace-nowrap text-gray-900 font-semibold">
                    © Innovia Engineering {new Date().getFullYear()}
                </p>
            </div>
        </div>
    )
}

export default Sidebar;
